import { render, staticRenderFns } from "./UserDefenceProgramDescription.vue?vue&type=template&id=f1404064&"
import script from "./UserDefenceProgramDescription.vue?vue&type=script&lang=js&"
export * from "./UserDefenceProgramDescription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports